import styles from './SegmentedControl.module.css';

import {
    SegmentedControl as MantineSegmentedControl,
    SegmentedControlProps as MantineSegmentedControlProps,
} from '@mantine/core';
import { cva, VariantProps } from 'class-variance-authority';

const variants = cva(styles.base, {
    variants: {
        size: {
            sm: styles.small,
            lg: styles.large,
        },
    },
    defaultVariants: {
        size: 'lg',
    },
});

export type SegmentedControlProps = MantineSegmentedControlProps & VariantProps<typeof variants>;

export const SegmentedControl = ({ withItemsBorders = false, size, ...props }: SegmentedControlProps) => {
    return (
        <MantineSegmentedControl
            className={variants({ size })}
            withItemsBorders={withItemsBorders}
            {...props}
        />
    );
};
